export class LicenseArea {

  licenseName: string = ''; // a capital letter (ex. A, B, C, etc.)

  licenseLocation: string = ''; // textual location description

  gearType: string = ''; // gear type the license area belongs to 

  isChecked: boolean = false; // for programmatical use only

  constructor(licenseName: string = '', licenseLocation: string = '', gearType: string = '', isChecked: boolean = false) {
    this.licenseName = licenseName;
    this.licenseLocation = licenseLocation;
    this.gearType = gearType;
    this.isChecked = isChecked;
  }

  public toString(): string {
    return this.licenseName + ' (' + this.licenseLocation + ')';
  }

  public isValid(): boolean {
    return !!this.licenseName && !!this.licenseLocation;
  }

  public isEqual(inputArea: LicenseArea): boolean {
    return inputArea.licenseName === this.licenseName;
  }

  // transform anonymous data into license area object
  public static transformAnonymous(licenseArea: any): LicenseArea {
    return new LicenseArea(
      licenseArea.licenseName ?? '',
      licenseArea.licenseLocation ?? '',
      licenseArea.gearType ?? '',
      licenseArea.isChecked ?? false
    );
  }

}
